// eslint-disable-next-line import/named
import { Dispatch } from "redux";

import {
  TOGGLE_BUY_INTERNET_TIME_MODAL,
  TOGGLE_RESPONSE_BUY_INTERNET_TIME_MODAL,
} from "../consts";

export const toggleBuyInternetTimeModal = (isShow = false) => {
  return (dispatch: Dispatch) => {
    dispatch({
      type: TOGGLE_BUY_INTERNET_TIME_MODAL,
      payload: isShow,
    });
  };
};

export const toggleResponseInternetTimeModal = (
  isShow = false,
  isError = false
) => {
  return (dispatch: Dispatch) => {
    dispatch({
      type: TOGGLE_RESPONSE_BUY_INTERNET_TIME_MODAL,
      payload: {
        isShow,
        isError,
      },
    });
  };
};
